import { Wrapper } from '@googlemaps/react-wrapper';

import {
  SingleLocationMapView,
  MapLocation,
} from '@virginexperiencedays/components-v2/src/layout/Maps';
import { Button } from '@virginexperiencedays/components-v2/src/layout/Button';
import { Image } from '@virginexperiencedays/components-v2/src/layout/Image';
import type { Location } from '@virginexperiencedays/products';

type RenderMapProps = {
  locations: Location[];
  isStatic: boolean;
  gmapApiKey: string;
  width: number;
  containerHeight: number;
  staticImageUrl: string;
  onClickStaticMap: () => void;
  zoom?: number;
};

export const RenderMap = ({
  locations,
  isStatic,
  gmapApiKey,
  width,
  containerHeight,
  staticImageUrl,
  onClickStaticMap,
  zoom,
}: RenderMapProps) => {
  if (width === 0) {
    return null;
  }

  if (locations.length < 2) {
    return (
      <SingleLocationMapView
        location={locations[0]}
        mapApiKey={gmapApiKey}
        width={width}
        height={containerHeight}
      />
    );
  }
  return isStatic ? (
    <Button variant="invisible" size="none" onClick={onClickStaticMap}>
      <Image
        className="w-full overflow-hidden rounded-lg object-fill"
        src={staticImageUrl}
        width={width}
        height={containerHeight}
        alt="google-maps-image"
      />
    </Button>
  ) : (
    <Wrapper apiKey={gmapApiKey}>
      <MapLocation width={width} height={containerHeight} locations={locations} zoom={zoom} />
    </Wrapper>
  );
};
